import React, { useRef } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { VennDiagramHeader } from "./VennDiagramHeader";
import { VennDiagramCanvas } from "./VennDiagramCanvas";
import { useVennDiagramExport } from "./hooks/useVennDiagramExport";
import type { VennDiagramData } from "@/lib/chat/parseVennDiagramBlock";

interface VennDiagramModalProps {
  open: boolean;
  onClose: () => void;
  data: VennDiagramData;
}

export const VennDiagramModal: React.FC<VennDiagramModalProps> = ({
  open,
  onClose,
  data,
}) => {
  const exportRef = useRef<HTMLDivElement>(null);
  const { exportPNG } = useVennDiagramExport(exportRef, data.title);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="flex h-[90vh] w-[95vw] max-w-none flex-col gap-0 p-0 sm:rounded-2xl [&>button:last-child]:hidden">
        <div ref={exportRef} className="flex flex-col flex-1 min-h-0">
          <VennDiagramHeader
            title={data.title}
            mode="expanded"
            onDownload={exportPNG}
            onToggleExpand={onClose}
          />
          <div className="flex-1 min-h-0 bg-muted/20">
            <VennDiagramCanvas data={data} height="fill" mode="expanded" />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
